import { useEffect, useState } from 'react';
import { nanoid } from 'nanoid';
import { usePopper } from 'react-popper';
import Icon from '@/core/icon';
import { useSpacePublicZustandStore } from '@/helpers/spacepublicprovider';
import { useTranslation } from '@/helpers/translate';
import { FormuleBody } from '@/components/space/public/byCategory/formule';
import CalendarSelectableStore from '@/components/calendar/store';

function FormuleHead({ formule, noPopover, noCaret }) {
  const { t } = useTranslation();


  return (
    <>
      <div
        className={`transition group shadow-light border border-purple-1 rounded-lg hover:shadow-none ${noPopover ? 'shadow-none border-none px-0 group cursor-pointer border border-purple-1 rounded-lg flex items-center pt-1 py-3' : 'py-3 px-3'}`}
      >
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center text-base">
            <div className="text-2xl text-purple">
              {formule.excl_tax}
              €
              <sup className="top-0 ml-2 text-2xl text-purple-5/70">
                par
                {' '}
                {t(formule.day ? 'space:formules.day' : 'pers.')}
              </sup>
            </div>
            {noCaret ? <Icon name="caret" className="w-3 ml-2 fill-current text-dark-light group-hover:text-black" /> : ''}
          </div>
        </div>
      </div>
    </>
  );
}

function Formules({ formules }) {
  const [reactKey] = useState(nanoid());
  const [currentFormules, setCurrentFormules] = useState(formules);
  const [formule] = useState(formules?.[0]);
  
  if (!Object.entries(formule || {}).length) return null;
  
  return (<>
      <div>
        <FormuleHead {...{
          formule,
          noPopover: true,
          noCaret: currentFormules?.length > 1,
        }}
        />
      </div>
          </>);
}

export default Formules;
